<template>
<div>
   <h5 class="text-center">
     {{computeCaption(fields_en['please_tell_us_about_yourself'], this.$store.state.lang.value.toLowerCase())}}
    </h5>
  <div>
   <MinimalIdentityCheck :allowName="true" :nameRequired="true" :allowCode="false" :codeRequired="false" :allowDob="true" :dobRequired="true" :allowPhone="true" :phoneRequired="true" ref="minimalIdentityCheck"/>
    <div class="row">
      <div class="col-md-10 col-md-offset-1">
          <div class="form-group">
          <small class="text-danger" v-show="errorData">{{computeCaption(errorData, this.$store.state.lang.value.toLowerCase())}}</small>
          </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
  import {DatePicker} from 'element-ui'
  import axios from 'axios'
  import {FormatterUtils} from '../../../../../utils/Formatter.js'
  import {ValidationUtils} from '../../../../../utils/Validation.js'
  import MinimalIdentityCheck from '../../Utils/Sections/MinimalIdentityCheck.vue'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      MinimalIdentityCheck
    },
    mixins: [FormatterUtils, ValidationUtils, TranslationsUtils],
    data () {
      return {
        errorData: '',
        model: {
          firstName: '',
          lastName: '',
          dob: '',
          dob_pretty: '',
          phone: ''
        },
        fields_en: {
          please_tell_us_about_yourself: 'Please tell us about yourself'
        }
      }
    },
    methods: {
      async validate () {
        let minimalIdentityCheckValues = await this.$refs.minimalIdentityCheck.validate()
        if (minimalIdentityCheckValues) {
          if (minimalIdentityCheckValues.dob !== undefined && minimalIdentityCheckValues.dob !== '') {
            this.model.dob = minimalIdentityCheckValues.dob
          }
          if (minimalIdentityCheckValues.dob_pretty !== undefined && minimalIdentityCheckValues.dob_pretty !== '') {
            this.model.dob_pretty = minimalIdentityCheckValues.dob_pretty
          }
          if (minimalIdentityCheckValues.firstName !== undefined && minimalIdentityCheckValues.firstName !== '') {
            this.model.firstName = minimalIdentityCheckValues.firstName
          }
          if (minimalIdentityCheckValues.lastName !== undefined && minimalIdentityCheckValues.lastName !== '') {
            this.model.lastName = minimalIdentityCheckValues.lastName
          }
          if (minimalIdentityCheckValues.phone !== undefined && minimalIdentityCheckValues.phone !== '') {
            this.model.phone = minimalIdentityCheckValues.phone
          }
        } else {
          return false
        }
        return new Promise((resolve, reject) => {
          axios.get(process.env.SERVER_URI + '/kit_check_user_data/' + this.$store.state.kit.site_code, { params: this.model })
          .then(async (response) => {
            if (response.data.error) {
              this.errorData = response.data.error
              reject(new Error('Invalid Data!'))
            } else {
              this.errorData = ''
              this.model.signature = this.$store.state.kit.userData
              this.$store.state.kit.userData = this.model
              this.$store.state.display_kit_instruction = false
            }
            resolve(true)
          }).catch(() => {
            this.errorData = 'Invalid Data or server issues!'
            reject(new Error('Invalid Data or server issues!'))
          })
        })
      }
    }
  }
</script>
<style scoped>

>>> .el-select--large{
      width: 100%;
    }

  h5{
    margin-bottom: 25px;
  }

  .text{
    text-align: center;
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/RegistrationKit/Wizard/Data.vue